import { cx } from '@emotion/css';
import { Typography } from '@mui/material';

export const SummaryLine = ({
  property,
  value,
  isBold = false,
}: {
  property: string;
  value: string;
  isBold?: boolean;
}) => {
  return (
    <div className="flex justify-between">
      <span
        className={cx(isBold ? 'text-black font-semibold' : 'text-gray-500')}
      >
        {property}
      </span>
      <Typography sx={{ fontWeight: isBold ? '900' : '600' }}>
        {value}
      </Typography>
    </div>
  );
};
